import { useEffect, useState } from "react";

export function BoostBanner({ until, testId = "sky-boost" }) {
  const [left, setLeft] = useState(() => new Date(until) - Date.now());
  useEffect(() => { const t = setInterval(() => setLeft(new Date(until) - Date.now()), 1000); return () => clearInterval(t); }, [until]);
  if (!until || left <= 0) return null;
  const s = Math.floor(left / 1000);
  const clock = `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
  return (
    <div className="relative rounded-2xl px-4 py-3 bg-gradient-to-r from-amber-300 via-pink-300 to-amber-200 text-indigo-950 font-extrabold text-sm flex items-center justify-between gap-2 sky-boost" data-testid={testId}>
      <span>🌠 Sternschnuppen-Abend: Jeder Beitrag zählt doppelt!</span>
      <span className="tabular-nums shrink-0" data-testid={`${testId}-timer`}>noch {clock}</span>
    </div>
  );
}
